import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { certificationSlice, CertificationSliceType } from './certification';
import { createSelectors } from './helper';
import { NotificationSliceType, notificationSlice } from './notification';
import { projectSlice, ProjectSliceType } from './project';
import { userSlice, UserSliceType } from './user';

export type StoreGlobalType = NotificationSliceType;

type StoreType = StoreGlobalType & ProjectSliceType & CertificationSliceType & UserSliceType;

/**
  DOCS:
  - https://docs.pmnd.rs/zustand/guides/typescript#slices-pattern
  - https://github.com/pmndrs/zustand/blob/main/docs/guides/typescript.md
  - https://github.com/pmndrs/zustand/blob/main/docs/guides/auto-generating-selectors.md
 */

const storeRoot = create<StoreType>()(
  devtools(
    immer((...params) => ({
      ...notificationSlice(...params),
      ...projectSlice(...params),
      ...certificationSlice(...params),
      ...userSlice(...params),
    })),
    { name: 'Wirk worker Store', serialize: { options: true } },
  ),
);

const store = createSelectors(storeRoot);

export default store;
